import { Skeleton } from '@/components/ui/skeleton';

/** Content-area placeholder while a settings tab chunk loads. No copy. */
export function SettingsTabPanelSkeleton() {
  return (
    <div
      className="space-y-6"
      aria-busy="true"
      aria-live="polite"
      role="status"
    >
      <div className="space-y-2">
        <Skeleton className="h-8 w-56 bg-ds-gray-subtlest" />
        <Skeleton className="h-4 w-full max-w-md bg-ds-gray-subtlest" />
      </div>
      <div className="space-y-4 rounded-lg border border-ds-border-subtlest p-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-10 w-full bg-ds-gray-subtlest" />
        ))}
      </div>
    </div>
  );
}
